module.exports = __webpack_public_path__ + "img/头部.90242d7f.png";